export default __webpack_public_path__ + "9624486b847034cb33caa0f403bf88b0.png";